import { applyPatch } from 'diff';

const UNIFIED_DIFF_RE = /^--- .+\n\+\+\+ .+\n@@ /m;

/** Heuristic check for whether a code block is a unified diff rather than full file content. */
export function looksLikeUnifiedDiff(text: string): boolean {
  return UNIFIED_DIFF_RE.test(text);
}

/** Applies a unified diff to `original`; returns the patched content, or null if the patch doesn't apply cleanly. */
export function tryApplyUnifiedDiff(original: string, diffText: string): string | null {
  const result = applyPatch(original, diffText);
  return result === false ? null : result;
}
